/** Centralized TanStack Query keys for the Analytics API. */
export const analyticsKeys = {
  all: ['analytics'] as const,
  overview: () => ['analytics', 'overview'] as const,
  connectedUsers: () => ['analytics', 'connected-users'] as const,
  popularRegions: () => ['analytics', 'popular-regions'] as const,
  userGeography: () => ['analytics', 'user-geography'] as const,
};
